<template>
  <div class="container-fluid mt-6 px-5">
    <div class="row mt-5">
      <el-skeleton v-if="loading" :rows="10" animated style="padding:24px" />
      <el-form v-else ref="subrogationForm" :model="form" style="padding:0" label-width="120px" label-position="right"
        size="small">
        <div style="padding:16px 0;font-size:16px;font-weight:600;border-bottom:1px solid #ddd;">
          Subroqasiya №{{ subrogationNumber }}
          <span v-if="formattedParticipants">— {{ formattedParticipants }}</span>
          <button type="button" size="sm" class="btn btn-outline-info mb-0 btn-sm ms-2"
            style="padding: 4px 10px; font-size: 12px !important;" @click="openTimeline">
            Statuslar
          </button>
          <!-- <el-button type="button" class="btn btn-outline-info mb-0 ms-3" style="color:#0d6efd" @click="openTimeline">
            Statuslar
          </el-button> -->
        </div>
        <el-tabs v-if="tabsReady" v-model="activeTab" plane>
          <el-tab-pane label="İlkin mərhələ" name="Info">
            <subrogation-info :id="id" :data="subrogationData" :last-status="lastStatus.subrogation" />
            <pre-court :id="id" :data="subrogationData" :last-status="lastStatus.subrogation"
              @status-updated="getStatuses" />
          </el-tab-pane>

          <el-tab-pane label="Məhkəmə" name="Məhkəmə" :disabled="!hasCourtReadyParticipants">
            <court :subrogation-id="id" @court-ready="updateCourtReady"
              :on-refresh-enforcement="refreshEnforcementData" />

          </el-tab-pane>

          <el-tab-pane label="İcra" name="Execution" :disabled="!hasCourtReadyParticipants">
            <enforcement-main ref="enforcementRef" :subrogation-id="id" />
          </el-tab-pane>

          <el-tab-pane label="Sənədlər" name="Sənədlər">
            <SubrogationDocsTable :subrogation-id="id" :loading="docsLoading" />
          </el-tab-pane>
          <el-tab-pane label="Təqvim" name="Jurnal">
            <scheduler-demo ref="calendarTab" :subrogation-id="id" />
          </el-tab-pane>
        </el-tabs>
      </el-form>

      <el-dialog v-model="timelineDialogVisible" title="Statuslar" width="52%" top="9vh">
        <el-skeleton v-if="loadingTimeline" :rows="8" animated style="padding:40px" />
        <el-timeline v-else>
          <el-timeline-item v-for="item in timeline" :key="item.id" color="green">
            <div style="border:1px solid #ccc;padding:16px;border-radius:8px;">
              <div style="display:flex;justify-content:space-between;align-items:center;">
                <div style="flex:1;">
                  <div style="font-weight:600;font-size:15px;color:#67748e;">
                    {{ item.statusText }}
                  </div>
                </div>
                <div style="width:140px;text-align:left;font-size:12px;color:#888;white-space:nowrap;">
                  {{ formatDateTime(item.date) }}
                </div>
                <el-button type="text" circle @click="toggleNoteInput(item)">
                  <i class="fa-solid fa-plus" style="font-size:18px;" />
                </el-button>
              </div>

              <el-divider v-if="item.showNoteInput" />

              <div v-if="item.showNoteInput" style="display:flex;flex-direction:column;gap:10px;">
                <el-input v-model="item.note" placeholder="Qeyd əlavə edin" type="textarea" rows="3" clearable />
                <soft-button type="button" size="medium" :loading="item.isSaving" style="align-self:flex-end;"
                  @click="saveNote(item)">
                  Yadda saxla
                </soft-button>

                <div v-if="item.notes?.length" style="margin-top:10px;">
                  <div style="font-weight:600;margin-bottom:8px;">Qeydlər</div>
                  <div v-for="note in item.notes" :key="note.id"
                    style="background:#f8f9fa;padding:10px;margin-bottom:8px;border-radius:6px;">
                    <div style="display:flex;justify-content:space-between;align-items:center;">
                      <div>
                        <p style="margin:0;">{{ note.note }}</p>
                        <div style="font-size:12px;color:#666;">
                          {{ note.createUserName || 'İstifadəçi' }}
                        </div>
                      </div>
                      <div style="display:flex;gap:10px;align-items:center;">
                        <el-switch :model-value="note.active" :active-value="true" :inactive-value="false"
                          style="--el-switch-on-color:#28a745;--el-switch-off-color:#dc3545;" size="small"
                          @change="v => onNoteStatusChange(v, note)" />
                        <el-button type="text" size="small" style="color:red;" @click="deleteNote(note, item)">
                          <i class="fa-solid fa-trash-can" />
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import SubrogationInfo from '@/project/PreCourt/Components/SubrogationInfo.vue'
import PreCourt from '@/project/PreCourt/Components/PreCourt.vue'
import { LastSubrogationStatus, GetSubrogationById } from '@/project/Source/subrogations'
import { LastCourtCaseStatus, GetCourtCases } from '@/project/Source/courts'
import Court from '@/project/Court/Components/Court.vue'
import { GetParticipants } from '@/project/Source/participants'
import EnforcementMain from '@/project/Enforcement/Main.vue'
import SubrogationDocsTable from "@/project/Components/Tables/SubrogationDocsTable.vue"

import {
  CreateSubrogationStatusNote,
  DeleteSubrogationStatusNote,
  UpdateSubrogationStatusNote,
  GetStatusNotes,
  GetSubrogationStatuses
} from '@/project/Source/common'
import SchedulerDemo from '@/project/Components/SchedulerDemo.vue'
import SoftButton from '@/components/SoftButton.vue'

export default {
  components: {
    SubrogationInfo,
    PreCourt,
    SubrogationDocsTable,
    Court,
    EnforcementMain,
    SchedulerDemo,
    SoftButton
  },
  props: {
    id: { type: [String, Number], required: true }
  },
  data() {
    return {
      enforcementKey: 1,
      timelineDialogVisible: false,
      timeline: [],
      loadingTimeline: false,
      loading: false,
      activeTab: null,
      tabsReady: false,
      subrogationData: {},
      form: {},
      hasCourtReadyParticipants: false,
      lastStatus: { subrogation: null, court: null },
      subrogationNumber: null,
      participants: [],
      uid: this.$store.state.userId
    }
  },
  computed: {
    formattedParticipants() {
      return this.participants
        .map(p => (p.personType === 1 ? `${p.name} ${p.surname}` : p.name))
        .join(', ')
    }
  },
  watch: {
    activeTab(v) {
      if (v === 'Jurnal') this.$refs.calendarTab?.forceCalendarResize()
    }
  },
  mounted() {
    this.getSubrogationData()
    this.getStatuses()
    this.getSubrogationParticipants()
    this.getData()
  },
  methods: {
    refreshEnforcementData() {
      this.$refs.enforcementRef?.loadCourtExecutions?.();
    },
    handleRefreshExecutions() {
      const comp = this.$refs.enforcementRef;
      comp?.loadCourtExecutions?.();
    },
    updateCourtReady(v) {
      this.hasCourtReadyParticipants = v
    },
    openTimeline() {
      this.timelineDialogVisible = true
      this.getData()
    },
    async getData() {
      this.loadingTimeline = true
      try {
        const { data } = await GetSubrogationStatuses(this.id)
        if (data.data?.length) {
          this.timeline = data.data.map(i => ({
            ...i,
            note: '',
            isSaving: false,
            notes: [],
            showNoteInput: false
          }))
          this.timeline.forEach(this.getNotes)
        } else this.$message.error('Status tapılmadı')
      } catch {
        this.$message.error('Status yüklənmədi')
      } finally {
        this.loadingTimeline = false
      }
    },
    async getNotes(item) {
      try {
        const { data } = await GetStatusNotes(item.id)
        const notes = data.data ? data.data.map(n => ({ ...n, active: n.status })) : []
        const idx = this.timeline.findIndex(t => t.id === item.id)
        if (~idx) this.timeline.splice(idx, 1, { ...this.timeline[idx], notes })
      } catch {
        this.$message.error('Qeydlər yüklənmədi')
      }
    },
    formatDateTime(s) {
      if (!s) return ''
      const d = new Date(s)
      const pad = n => String(n).padStart(2, '0')
      return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
    async saveNote(item) {
      if (!item.note?.trim()) return this.$message.warning('Qeyd yoxdur')
      const idx = this.timeline.findIndex(t => t.id === item.id)
      if (idx === -1) return
      const obj = { ...this.timeline[idx], isSaving: true }
      this.timeline[idx] = obj
      try {
        await CreateSubrogationStatusNote({
          subrogationStatusId: item.id,
          note: item.note,
          user: this.uid
        })
        this.$message.success('Uğurlu əməliyyat!')
        obj.note = ''
        this.timeline[idx] = { ...obj }
        await this.getData()
      } catch {
        this.$message.error('Səhв əməliyyat!')
      } finally {
        obj.isSaving = false
        this.timeline[idx] = { ...obj }
      }
    },
    toggleNoteInput(i) {
      i.showNoteInput = !i.showNoteInput
    },
    onNoteStatusChange(v, n) {
      if (n.active === v) return
      UpdateSubrogationStatusNote({ id: n.id, status: v, uid: this.uid })
        .then(() => {
          n.active = v
          n.status = v
          this.$message.success(v ? 'Qeyd aktiv edildi' : 'Qeyd deaktiv edildi')
        })
        .catch(() => this.$message.error('Status dəyişmək olmadı'))
    },
    deleteNote(n, item) {
      DeleteSubrogationStatusNote({ id: n.id, uid: this.uid })
        .then(() => {
          this.$message.success('Qeyd silindi')
          item.notes = item.notes.filter(x => x.id !== n.id)
        })
        .catch(() => this.$message.error('Qeyd silmək olmadı'))
    },
    getSubrogationData() {
      this.loading = true
      GetSubrogationById(this.id)
        .then(r => {
          this.subrogationData = (r.data.data && r.data.data[0]) || {}
          this.subrogationNumber = this.subrogationData.subrogationNumber
        })
        .finally(() => (this.loading = false))
    },
    async getStatuses() {
      try {
        const [subRes, courtRes] = await Promise.all([
          LastSubrogationStatus(this.id),
          GetCourtCases(this.id)
        ])
        this.lastStatus.subrogation = subRes.data
        const cases = courtRes.data.data || []
        if (cases.length) {
          const latest = cases.sort((a, b) => b.id - a.id)[0]
          const { data } = await LastCourtCaseStatus(latest.id)
          this.lastStatus.court = data.data.status
        } else this.lastStatus.court = null

        this.determineActiveTab()
      } catch (e) {
        console.error('Failed to load statuses:', e)
        this.activeTab = 'Info'
      } finally {
        this.tabsReady = true
      }
    },
    determineActiveTab() {
      const courtStatus = this.lastStatus.court;
      const subrogationStage = this.lastStatus.subrogation;

      if (courtStatus && courtStatus !== 0) {
        switch (courtStatus) {
          case 50: // İşə xitam verilib
          case 45: // Öhdəlik yerinə yetirilib
          case 35: // İcraya göndərilib
            this.activeTab = 'Jurnal';
            break;
          case 30: // Məhkəmə işi yaradılıb
            this.activeTab = 'Məhkəmə';
            break;
          default:
            this.activeTab = 'Execution';
            break;
        }
      } else if (subrogationStage != null) {
        switch (subrogationStage) {
          case 50: // İşə xitam verilib
          case 45: // Öhdəlik yerinə yetirilib
            this.activeTab = 'Info';
            break;
          case 35: // İcraya göndərilib
            this.activeTab = 'Execution';
            break;
          case 20: // Məhkəmə hazırlığına göndərilib
          case 25: // İş məhkəməyə göndərilib
          case 30: // Məhkəmə işi yaradılıb
            this.activeTab = 'Məhkəmə';
            break;
          default:
            this.activeTab = 'Info';
            break;
        }
      } else {
        this.activeTab = 'Info';
      }
    },
    getSubrogationParticipants() {
      GetParticipants(this.id).then(r => (this.participants = r.data.data))
    }
  }
}
</script>

<style scoped></style>
